import api from './api';

class ClientService {
  async getAllClients(params = {}) {
    const response = await api.get('/clients', { params });
    return response.data;
  }

  async getClient(id) {
    const response = await api.get(`/clients/${id}`);
    console.log('Client data:', response);
    return response.data;
  }

  async createClient(clientData) {
    const response = await api.post('/clients', clientData);
    return response.data;
  }

  async updateClient(id, clientData) {
    const response = await api.put(`/clients/${id}`, clientData);
    return response.data;
  }

  async deleteClient(id) {
    const response = await api.delete(`/clients/${id}`);
    return response.data;
  }

  async searchClients(query) {
    const response = await api.get('/clients/search', { params: { q: query } });
    return response.data;
  }

  async getClientStatistics() {
    const response = await api.get('/clients/statistics');
    return response.data;
  }

  async exportClients(format = 'csv') {
    const response = await api.get('/clients/export', {
      params: { format },
      responseType: 'blob'
    });
    return response.data;
  }
}

export default new ClientService();